import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserUtils } from '@azure/msal-browser'
import { initErrorCapture } from './utils/errorCapture'
import { initStaleBuildRecovery } from './utils/staleBuildRecovery'
import App from './App.tsx'
import './styles/print.css'

// Start capturing console errors/warnings before React mounts
initErrorCapture();
// After a deploy, reload once instead of failing on code files the old build referenced
initStaleBuildRecovery();

/**
 * MSAL v5 popup flow: after Azure AD auth, the popup redirects back here with #code=...
 * The popup must broadcast the response to the parent window via BroadcastChannel, then close.
 * If we're NOT in a popup, render the app normally.
 */
if (BrowserUtils.isInPopup()) {
  // Dynamically import the redirect bridge to broadcast the auth response to the parent window
  import('@azure/msal-browser/redirect-bridge')
    .then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
    .catch(() => {
      // If broadcast fails, try closing the popup anyway
      try { window.close(); } catch { /* ignore */ }
    });
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
